import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { $createParagraphNode, $getSelection, $isRangeSelection } from "lexical";
import { INSERT_TABLE_COMMAND } from "@lexical/table";
import { useValidationService } from "../../../../../services/hooks/index.js";
import { Dialog, DialogContent } from "../../../../../Dialog/index.js";
import { Button } from "../../../../../Button/index.js";
import { TextInput } from "../../../../index.js";
import { Grid } from "../../../../../Grid/index.js";
import { Box } from "../../../../../Box/index.js";
import { useForm } from "../../hooks/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const MAX_ROWS_AND_COLUMNS_VALUE = 10;
const MIN_ROWS_AND_COLUMNS_VALUE = 1;
const TableDialog = (t0)=>{
    const $ = c(74);
    const { editor, open, onClose } = t0;
    const [rows, setRows] = useState("5");
    const [columns, setColumns] = useState("5");
    const validator = useValidationService();
    let t1;
    if ($[0] !== columns || $[1] !== rows) {
        t1 = {
            rows,
            columns
        };
        $[0] = columns;
        $[1] = rows;
        $[2] = t1;
    } else t1 = $[2];
    const allValues = t1;
    let t2;
    if ($[3] !== validator) {
        t2 = validator.required("\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
        $[3] = validator;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== validator) {
        t3 = validator.maxValue(MAX_ROWS_AND_COLUMNS_VALUE, "\u0422\u043E\u043B\u044C\u043A\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 1 \u0434\u043E 10");
        $[5] = validator;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== validator) {
        t4 = validator.minValue(MIN_ROWS_AND_COLUMNS_VALUE, "\u0422\u043E\u043B\u044C\u043A\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 1 \u0434\u043E 10");
        $[7] = validator;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = [
            t2,
            t3,
            t4
        ];
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== validator) {
        t6 = validator.required("\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
        $[13] = validator;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== validator) {
        t7 = validator.maxValue(MAX_ROWS_AND_COLUMNS_VALUE, "\u0422\u043E\u043B\u044C\u043A\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 1 \u0434\u043E 10");
        $[15] = validator;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== validator) {
        t8 = validator.minValue(MIN_ROWS_AND_COLUMNS_VALUE, "\u0422\u043E\u043B\u044C\u043A\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 1 \u0434\u043E 10");
        $[17] = validator;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
        t9 = [
            t6,
            t7,
            t8
        ];
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t5 || $[24] !== t9) {
        t10 = {
            rows: t5,
            columns: t9
        };
        $[23] = t5;
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    const fieldValidators = t10;
    const { errors, touched, validateField, hasValidationErrors, showError, handleBlur } = useForm(allValues, fieldValidators);
    let t11;
    if ($[26] !== showError || $[27] !== validateField) {
        t11 = (value)=>_async_to_generator(function*() {
                setRows(()=>value || "");
                yield validateField("rows", value);
                showError("rows");
            })();
        $[26] = showError;
        $[27] = validateField;
        $[28] = t11;
    } else t11 = $[28];
    const handleChangeRowsInput = t11;
    let t12;
    if ($[29] !== showError || $[30] !== validateField) {
        t12 = (value_0)=>_async_to_generator(function*() {
                setColumns(()=>value_0 || "");
                yield validateField("columns", value_0);
                showError("columns");
            })();
        $[29] = showError;
        $[30] = validateField;
        $[31] = t12;
    } else t12 = $[31];
    const handleChangeColumnsInput = t12;
    let t13;
    if ($[32] !== columns || $[33] !== editor || $[34] !== onClose || $[35] !== rows) {
        t13 = ()=>{
            editor.update(()=>{
                editor.dispatchCommand(INSERT_TABLE_COMMAND, {
                    columns,
                    rows
                });
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    const anchorNode = selection.anchor.getNode();
                    let tableNode = anchorNode;
                    while(tableNode && "table" !== tableNode.getType())tableNode = tableNode.getParent();
                    if (tableNode) {
                        const paragraphNode = $createParagraphNode();
                        const sibling = tableNode.getNextSibling();
                        if (sibling) return void sibling.replace(paragraphNode);
                        tableNode.insertAfter(paragraphNode);
                    }
                }
            });
            onClose();
        };
        $[32] = columns;
        $[33] = editor;
        $[34] = onClose;
        $[35] = rows;
        $[36] = t13;
    } else t13 = $[36];
    const onSubmit = t13;
    let t14;
    if ($[37] !== onClose) {
        t14 = /*#__PURE__*/ jsx(Button, {
            size: "large",
            variant: "tertiaryLight",
            type: "button",
            onClick: onClose,
            children: "Отменить"
        });
        $[37] = onClose;
        $[38] = t14;
    } else t14 = $[38];
    let t15;
    if ($[39] !== hasValidationErrors) {
        t15 = /*#__PURE__*/ jsx(Button, {
            disabled: hasValidationErrors,
            size: "large",
            variant: "primary",
            type: "submit",
            children: "Добавить"
        });
        $[39] = hasValidationErrors;
        $[40] = t15;
    } else t15 = $[40];
    let t16;
    if ($[41] !== t14 || $[42] !== t15) {
        t16 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t14,
                t15
            ]
        });
        $[41] = t14;
        $[42] = t15;
        $[43] = t16;
    } else t16 = $[43];
    const t17 = touched.rows && !!errors.rows;
    const t18 = touched.rows && errors.rows || "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 1 \u0434\u043E 10";
    let t19;
    if ($[44] !== handleBlur) {
        t19 = handleBlur("rows");
        $[44] = handleBlur;
        $[45] = t19;
    } else t19 = $[45];
    let t20;
    if ($[46] !== handleChangeRowsInput || $[47] !== rows || $[48] !== t17 || $[49] !== t18 || $[50] !== t19) {
        t20 = /*#__PURE__*/ jsx(Grid, {
            item: true,
            xs: 6,
            children: /*#__PURE__*/ jsx(Box, {
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ jsx(TextInput, {
                    type: "number",
                    label: "\u0421\u0442\u0440\u043E\u043A\u0438",
                    required: true,
                    placeholder: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0442\u0440\u043E\u043A",
                    value: rows,
                    onChange: handleChangeRowsInput,
                    name: "rows",
                    error: t17,
                    helperText: t18,
                    onBlur: t19
                })
            })
        });
        $[46] = handleChangeRowsInput;
        $[47] = rows;
        $[48] = t17;
        $[49] = t18;
        $[50] = t19;
        $[51] = t20;
    } else t20 = $[51];
    const t21 = touched.columns && !!errors.columns;
    const t22 = touched.columns && errors.columns || "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 1 \u0434\u043E 10";
    let t23;
    if ($[52] !== handleBlur) {
        t23 = handleBlur("columns");
        $[52] = handleBlur;
        $[53] = t23;
    } else t23 = $[53];
    let t24;
    if ($[54] !== columns || $[55] !== handleChangeColumnsInput || $[56] !== t21 || $[57] !== t22 || $[58] !== t23) {
        t24 = /*#__PURE__*/ jsx(Grid, {
            item: true,
            xs: 6,
            children: /*#__PURE__*/ jsx(Box, {
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ jsx(TextInput, {
                    type: "number",
                    label: "\u0421\u0442\u043E\u043B\u0431\u0446\u044B",
                    required: true,
                    placeholder: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432",
                    value: columns,
                    onChange: handleChangeColumnsInput,
                    name: "columns",
                    error: t21,
                    helperText: t22,
                    onBlur: t23
                })
            })
        });
        $[54] = columns;
        $[55] = handleChangeColumnsInput;
        $[56] = t21;
        $[57] = t22;
        $[58] = t23;
        $[59] = t24;
    } else t24 = $[59];
    let t25;
    if ($[60] !== t20 || $[61] !== t24) {
        t25 = /*#__PURE__*/ jsxs(Grid, {
            container: true,
            spacing: "24",
            children: [
                t20,
                t24
            ]
        });
        $[60] = t20;
        $[61] = t24;
        $[62] = t25;
    } else t25 = $[62];
    let t26;
    if ($[63] !== onClose || $[64] !== t16 || $[65] !== t25) {
        t26 = /*#__PURE__*/ jsx(DialogContent, {
            title: "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0442\u0430\u0431\u043B\u0438\u0446\u044B",
            onClose: onClose,
            actions: t16,
            children: t25
        });
        $[63] = onClose;
        $[64] = t16;
        $[65] = t25;
        $[66] = t26;
    } else t26 = $[66];
    let t27;
    if ($[67] !== onSubmit || $[68] !== t26) {
        t27 = /*#__PURE__*/ jsx("form", {
            onSubmit: onSubmit,
            children: t26
        });
        $[67] = onSubmit;
        $[68] = t26;
        $[69] = t27;
    } else t27 = $[69];
    let t28;
    if ($[70] !== onClose || $[71] !== open || $[72] !== t27) {
        t28 = /*#__PURE__*/ jsx(Dialog, {
            open: open,
            onClose: onClose,
            children: t27
        });
        $[70] = onClose;
        $[71] = open;
        $[72] = t27;
        $[73] = t28;
    } else t28 = $[73];
    return t28;
};
export { TableDialog };
